module.exports = __webpack_public_path__ + "img/img-apple-store.d2723bc6.png";